import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';

import AddItemModal from 'components/homepage-layouts/items/AddItemModal/AddItemModal';
import {closeAddHomepageItemModal, submitAddHomepageItemModal} from './actions';
import addHomepageItemFormConfig from './addHomepageItemFormConfig';
import {formDataManager} from "hoc/formDataManager";

const mapStateToProps = (state) => {
  return {
    modalOpen: state.addHomepageItemReducer.showingAddHomepageItemModal
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleClose: () => dispatch(closeAddHomepageItemModal()),
  onSaveData: (data) => dispatch(submitAddHomepageItemModal(data))
});

let AddHomepageItemFormDataManager = formDataManager({
    lang: "en-US"
}, addHomepageItemFormConfig);

const ConnectedAddItemModal = connect(mapStateToProps, mapDispatchToProps);

const AddHomepageItemModalContainer = compose(
    ConnectedAddItemModal,
    AddHomepageItemFormDataManager
)(AddItemModal);

export default AddHomepageItemModalContainer;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/AddItemModal/AddItemModalContainer.jsx